module.exports = __webpack_public_path__ + "static/media/building.6c0fa893.svg";